'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import RealtimeMonitoring from './RealtimeMonitoring';
import EmissionCalculator from './EmissionCalculator';
import ActivityBasedTracking from './ActivityBasedTracking';
import IoTIntegration from './IoTIntegration';
import MRVValidation from './MRVValidation';
import IndustryModules from './IndustryModules';
import Footer from '@/app/homepage/components/Footer';
import LanguageSelector from '@/app/homepage/components/LanguageSelector';
import WhatsAppButton from '@/app/homepage/components/WhatsAppButton';

const EmissionPlatformInteractive = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [activeScope, setActiveScope] = useState<'scope1' | 'scope2' | 'scope3'>('scope1');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('gencarbon_language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleLanguageChange = (language: string) => {
    setCurrentLanguage(language);
    localStorage.setItem('gencarbon_language', language);
  };

  return (
    <>
      {/* Language Selector - Fixed Position */}
      <div className="fixed top-20 right-4 z-40">
        <LanguageSelector
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Main Content */}
      <HeroSection currentLanguage={currentLanguage} />
      <RealtimeMonitoring currentLanguage={currentLanguage} activeScope={activeScope} onScopeChange={setActiveScope} />
      <EmissionCalculator currentLanguage={currentLanguage} />
      <ActivityBasedTracking currentLanguage={currentLanguage} />
      <IoTIntegration currentLanguage={currentLanguage} />
      <MRVValidation currentLanguage={currentLanguage} />
      <IndustryModules currentLanguage={currentLanguage} />
      <Footer currentLanguage={currentLanguage} />

      {/* WhatsApp Floating Button */}
      <WhatsAppButton currentLanguage={currentLanguage} />
    </>
  );
};

export default EmissionPlatformInteractive;